// extracted by mini-css-extract-plugin
export default {"card":"Card__card--TFdAv","clickable":"Card__clickable--i42xS","active":"Card__active--OAx2x","indicator":"Card__indicator--mQmyC","not-available":"Card__not-available--oDgyL"};